import Cookies from 'js-cookie'


export const SearchCities = (title, cities) => {
  return cities.filter(city => city.FarsiName.includes(title));
}

export const GetAgency = (setUserInfo, setSearchData, setLocationName, http, setLocation = false) => {
  try {
    http({
      // url of the api endpoint (can be changed)
      url: "/authenticate/get/agency",
      method: "GET",
      headers: {
        "Authorization": `Bearer ${Cookies.get('token')}`
      }
    }).then((res) => {
      console.log("get/agency", res)
      localStorage.setItem('agency', JSON.stringify(res.data.result.agency))
      Cookies.set('agency', JSON.stringify(res.data.result.agency))

      if (res.data.result.user && Object.keys(res.data.result.user).length)
        localStorage.setItem('subUserInfo', JSON.stringify(res.data.result.user))
      Cookies.set('subUserInfo', JSON.stringify(res.data.result.user))
      if (setLocation) {
        localStorage.setItem('locationId', res.data.result.LocationId)
        setLocationIdCookie(res?.data?.result?.agency?.LocationId)

        localStorage.setItem('locationName', res.data.result.LocationName)
        Cookies.set('locationName', res.data.result.LocationName)
        setLocationName(res.data.result.LocationName)
      }
      setUserInfo(res.data.result.agency)

      setSearchData({ name: 'AgencyId', value: res.data.result.Id })
      // setSearchData({ name: 'LocationId', value: res.data.result.LocationId })
    });
  } catch (e) {
    console.error(e);
  }
}


export const newShade = (hexColor, magnitude) => {
  hexColor = hexColor.replace(`#`, ``);
  if (hexColor.length === 6) {
    const decimalColor = parseInt(hexColor, 16);
    let r = (decimalColor >> 16) + magnitude;
    r > 255 && (r = 255);
    r < 0 && (r = 0);
    let g = (decimalColor & 0x0000ff) + magnitude;
    g > 255 && (g = 255);
    g < 0 && (g = 0);
    let b = ((decimalColor >> 8) & 0x00ff) + magnitude;
    b > 255 && (b = 255);
    b < 0 && (b = 0);
    return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
  } else {
    return hexColor;
  }
};

export function lightOrDark(color) {
  let r, b, g, hsp
  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {

    // If HEX --> store the red, green, blue values in separate variables
    color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

    r = color[1];
    g = color[2];
    b = color[3];
  }
  else {

    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +("0x" + color.slice(1).replace(
      color.length < 5 && /./g, '$&$&'
    )
    );

    r = color >> 16;
    g = color >> 8 & 255;
    b = color & 255;
  }

  // HSP equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(
    0.299 * (r * r) +
    0.587 * (g * g) +
    0.114 * (b * b)
  );

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 127.5) {

    return 'light';
  }
  else {

    return 'dark';
  }
}

export function reloadPageWithClearCache() {
  window.location.reload(true)
}


export const getUserToken = () =>{
  return JSON.parse(Cookies.get('agency'))
}

export const getToken = () =>{
  return Cookies.get('token')
}

export const setUserCookie = (agency) =>{
  Cookies.set('agency', JSON.stringify(agency),{ expires: 60 })
}

export const setTokenCookie = (token) =>{
  Cookies.set('token', token,{ expires: 60 })
}

export const setLocationIdCookie = (locId) => {
  console.log("🚀 ~ setLocationIdCookie ~ locId:", locId)
 
  Cookies.set('locationId', locId,{ expires: 60 })
}

export const setLocationNameCookie = (locName) => {
   
 
  Cookies.set('locationName', locName,{ expires: 60 })
}


export const checkPropertyCount = () => {
  const userInfo = getUserToken()

  if(userInfo?.PropertyCount < 100)
    return true
  else
    return false
  
}